<script lang="ts">
    import { _ } from "svelte-i18n"
    import MagnifyIcon from "svelte-material-icons/Magnify.svelte"
    import ProductTeaserList from "../product/ProductTeaserList.svelte"
    import { navigate } from "../../../../vendor/svelte-routing"
    import { homeProductTeaser, title } from "../../config"

    let search: string
</script>

<svelte:head>
    <title>{title}</title>
    <meta name="description" content="{$_('meta.description')}" />
</svelte:head>

<div class="quicksearch">
    <form
        class="form"
        on:submit|preventDefault="{() => {
            navigate('/search?' + encodeURIComponent(search))
        }}"
    >
        <div class="input_holder">
            <input
                type="text"
                name="search"
                bind:value="{search}"
                placeholder="{$_('home.search-placeholder')}"
                required
            />
            <button type="submit" class="searchicon">
                {$_("home.search")}
                <MagnifyIcon />
            </button>
        </div>
    </form>
</div>

<!--
<section
    class="section_padding section-type-1"
    id="products_start"
>
    <div class="container">
        <ProductTeaserList
            title1="Beliebte Briefkastenprodukte"
            title2="Briefkastenanlagen"
            path="/brief-und-paketkaesten"
            moreLinkText="alle Briekastenanlagen"
            moreLinkURL="/brief-und-paketkaesten"
        />
    </div>
</section>
-->

{#each homeProductTeaser as t}
    <section class="section-type-1 section_padding" id="products_start">
        <div class="container">
            <ProductTeaserList {...t} direction="vertical" />
        </div>
    </section>
{/each}

<style lang="less">
    @import "../../css/variables.less";
    .quicksearch {
        display: none;
        z-index: 99;
        @media @tablet {
            display: block;
        }
        position: absolute;
        height: calc(var(--navheight_mobile) + 40px);
        @media (min-width: @res-desktop) {
            top: calc(var(--navheight) + 40px);
        }
        left: 0;
        right: 0;
        width: 350px;
        margin: 0 auto;
        button :global {
            font-size: 0px;
            svg {
                font-size: 24px;
            }
        }
        .input_holder {
            position: relative;
            .searchicon {
                .transition();
                border: 0;
                border-radius: 0;
                border-top-right-radius: var(--mainborder-radius);
                border-bottom-right-radius: var(--mainborder-radius);
                background: none;
                color: inherit;
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                border-left: solid 1px var(--border-color-2);
                padding: 5px;
                .flex();
                align-items: center;
                justify-content: center;
                &:before,
                &:after {
                    display: none;
                }
                &:hover {
                    background: var(--primary);
                    color: var(--on-primary);
                }
            }
            input {
                opacity: 0.8;
                .border-radius(var(--mainborder-radius));
                padding: 5px 30px 5px 10px;
            }
        }
    }
</style>
